import React, { FC, ReactNode } from 'react'
import { Modal } from 'react-bootstrap'

import './ModalTitle.scss'

interface Props {
  children?: ReactNode
}

export const ModalTitle: FC<Props> = ({ children }) => (
  <Modal.Title bsPrefix="modal-header-title">{children}</Modal.Title>
)
